<template>
	<div class="content" ref="ct">
	</div>
</template>
<script>
export default {
	mounted () {
		
		var s = document.createElement("script")
		s.src="https://consent.cookiebot.com/ccfe0aa0-4013-4c1f-b7bb-66f63c58f8c2/cd.js"
		this.$refs.ct.appendChild(s)
	},

}
</script>

<style>
	#privacy-policy h1, h2, h3 {
		text-align: left;
	}
</style>
<style scoped>
.container {
	overflow-wrap: break-word;
	word-wrap: break-word;
	-ms-word-break: break-all;
	/* This is the dangerous one in WebKit, as it breaks things wherever */
	word-break: break-all;
	/* Instead use this non-standard one: */
	word-break: break-word;
	/* Adds a hyphen where the word breaks, if supported (No Blink) */
	-ms-hyphens: auto;
	-moz-hyphens: auto;
	-webkit-hyphens: auto;
	hyphens: auto;
}

.header {
	font-size: 30px;
	text-align:center;
	margin-bottom: 10px;
}

.content {
	padding: 20px 0;
	color: #575A5C;
	margin: 0 auto;
	width: 90%;
	max-width: 1024px;
}
h2 {
	text-align: center;
}
p {
	font-size: 15px;
	text-align:justify;
	margin-bottom: 10px;
}
ul {
	font-size: 15px;
	text-align:justify;
	margin-left: 40px;
	list-style: initial;
}


</style>
